import { z } from 'zod'
import { responseSchema } from '@/core/types/Response.ts'
import { equalityDeviceInfoSchema } from '@/modules/sales/clients/types/EqualityDeviceInfo.ts'

export const equalityDeviceInfoResponseSchema = responseSchema(
  equalityDeviceInfoSchema
)

export type EqualityDeviceInfoResponse = z.infer<
  typeof equalityDeviceInfoResponseSchema
>
